import React from 'react';

const IconBantuanAjaib = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z"
        fill="#06090D"
      />
      <path
        d="M13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17C11 16.4477 11.4477 16 12 16C12.5523 16 13 16.4477 13 17Z"
        fill="#06090D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6019 8.49741C10.2633 8.79836 10 9.27136 10 10C10 10.5523 9.55228 11 9 11C8.44772 11 8 10.5523 8 10C8 8.72864 8.4867 7.70164 9.27314 7.00259C10.0412 6.3199 11.0369 6 12 6C12.9631 6 13.9588 6.3199 14.7269 7.00259C15.5133 7.70164 16 8.72864 16 10C16 11.5446 14.822 12.3242 14.143 12.7735C14.1125 12.7937 14.083 12.8132 14.0547 12.8321C13.2139 13.3926 13 13.614 13 14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14C11 12.4554 12.178 11.6758 12.857 11.2265C12.8875 11.2063 12.917 11.1868 12.9453 11.1679C13.7861 10.6074 14 10.386 14 10C14 9.27136 13.7367 8.79836 13.3981 8.49741C13.0412 8.1801 12.5369 8 12 8C11.4631 8 10.9588 8.1801 10.6019 8.49741Z"
        fill="#06090D"
      />
    </svg>
  );
};

export default IconBantuanAjaib;
